import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryEditRestrictionsEntryRemoteDto } from 'src/generated/signalR/directory-edit-restrictions-entry-remote-dto';

@Pipe({
   name: 'directoryColumnIsRestricted',
})
export class DirectoryColumnIsRestrictedPipe implements PipeTransform {
   transform(directoryColumn: DirectoryColumn, directoryEditRestricitons: DirectoryEditRestrictionsEntryRemoteDto[]): boolean {
      const restrictions = _(directoryEditRestricitons)
         .filter((res) => res.column === directoryColumn.organisationUnitColumnKey)
         .value();

      if (restrictions.length === 0) {
         return true;
      }
   }
}
